import defaultTheme from './default';

const drawerWidth = defaultTheme.drawerWidth;
const appBarMenuItemsColor = defaultTheme.appBarMenuItemsColor;
const appBarHeight = defaultTheme.appBarHeight;

const HeaderStyles = (theme) => ({
    appBar: {
      //zIndex: theme.zIndex.drawer + 1,
      //background:"#fff",
      [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        color:appBarMenuItemsColor,
      },
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {      
        width: `calc(100% - ${defaultTheme.default.drawer.miniWidth}px)`,
        marginLeft: defaultTheme.default.drawer.miniWidth,
        color:appBarMenuItemsColor,      
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    root: {
      width: "100%",
    },
    grow: {
      flexGrow: 1,
    },
    menuButton: {
      marginLeft: -12,
      marginRight: 20,
    },
    small:{
      margin: "auto 3px",
      width:"50px",
      height:"40px",    
    },
    /*left top corner mobile logo part */ 
    appbar:{
      height: appBarHeight,
    },
    title: {
      display: "none",
      [theme.breakpoints.up("sm")]: {
        display: "block",
      },
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    sectionMobile: {
      display: "flex",
  
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    elevationNone:{
      boxShadow: "none !important",

    }
  });

  export default HeaderStyles